import axios from "axios";
import { API_BASE, api } from "@/lib/api";

export async function uploadFile(file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const token = localStorage.getItem("slr_token");
  const { data } = await axios.post(`${API_BASE}/upload`, fd, {
    headers: { Authorization: `Bearer ${token}` },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  // Convert relative `/api/media/...` to absolute URL for use across the app.
  const url = data.url.startsWith("http") ? data.url : `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
  return { ...data, url };
}

export async function deleteMedia(mediaId) {
  await api.delete(`/media/${mediaId}`);
}
